// extracted by mini-css-extract-plugin
export const applyButtonWrapper = "OfferPage__applyButtonWrapper__EKNZd";
export const atlasGrotesk = "'AtlasGrotesk'";
export const block = "OfferPage__block__IiXe3";
export const blockContent = "OfferPage__blockContent__F0su0 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const blockParagraph = "OfferPage__blockParagraph__fuNvf";
export const blockParagraphLabel = "OfferPage__blockParagraphLabel__JH-J1 font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const blockParagraphValue = "OfferPage__blockParagraphValue__j2Rjm";
export const blockTitle = "OfferPage__blockTitle__wLMgr font-faces__sansBold__vF+EN font-faces__sans__uCf65";
export const blocks = "OfferPage__blocks__4HK6z";
export const blue = "OfferPage__blue__4iSB8";
export const bold = "700";
export const container = "OfferPage__container__A5Dnp";
export const divided = "OfferPage__divided__QN4IL";
export const expandDescription = "OfferPage__expandDescription__UUJln";
export const expandTermsButton = "OfferPage__expandTermsButton__Cssfg font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const footer = "OfferPage__footer__nOEq4";
export const green = "OfferPage__green__6Pd1d";
export const halfWidth = "OfferPage__halfWidth__5PaVp";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "OfferPage__header__t5KgF OfferPage__container__A5Dnp font-faces__serifMedium__n-4rV font-faces__serif__XseuP";
export const highlight = "OfferPage__highlight__fA8vY";
export const highlightInner = "OfferPage__highlightInner__LEv7i";
export const highlightMaxFontSize = "var(--highlight-font-size)";
export const highlightMinFontSize = "var(--highlight-min-font-size)";
export const highlightValue = "OfferPage__highlightValue__f9LgM";
export const highlights = "OfferPage__highlights__WF9jP";
export const hightlightLabel = "OfferPage__hightlightLabel__byYdY font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const image = "OfferPage__image__ZgyqW";
export const imageColumn = "OfferPage__imageColumn__zbY79";
export const isWide = "OfferPage__isWide__kPqIA";
export const medium = "500";
export const product = "OfferPage__product__tepFP";
export const productDescription = "OfferPage__productDescription__crKzH";
export const productDescriptionItem = "OfferPage__productDescriptionItem__Nmrhf";
export const productSubtitle = "OfferPage__productSubtitle__zCLDn font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const productTitle = "OfferPage__productTitle__DeP9i font-faces__sansLight__-1Yzy font-faces__sans__uCf65";
export const productTop = "OfferPage__productTop__uZnUz";
export const red = "OfferPage__red__4AgxM";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const solid = "OfferPage__solid__FmFzC";
export const terms = "OfferPage__terms__y7z-g font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const termsHeading = "OfferPage__termsHeading__ZoGQZ font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const termsSection = "OfferPage__termsSection__6qB4h";
export const termsText = "OfferPage__termsText__2U9z6 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";